import { render, staticRenderFns } from "./Student.vue?vue&type=template&id=5432aea4&"
import script from "./Student.vue?vue&type=script&lang=js&"
export * from "./Student.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports